import React from "react";

import { PageContainer } from "../../../../../../components/container/PageContainer";
import { BusinessPolicyNotesList } from "./BusinessPolicyNotesList";
import { useOutletContext } from "react-router-dom";
import { MODULE_NAMES } from "../../../../../../constants/enums";

export const BusinessActivitiesTabs: React.FC = () => {
    const data = useOutletContext() as any;
  const customerId = data[0];
  const customerPolicyId = data[1];

  const moduleInformation = {
    moduleId: customerPolicyId,
    moduleName: MODULE_NAMES.BUSINESS,
    subModuleName: MODULE_NAMES.BUSINESS,
    refColumnName: "customer_policy_id",
  };

  return (
    <PageContainer
      title="Activities"
      description="this is innerpage"
    >
        <BusinessPolicyNotesList
          customerId={customerId}
          customerPolicyId={customerPolicyId}
          moduleInformation={moduleInformation}
        />
    </PageContainer>
  );
};
